// extracted by mini-css-extract-plugin
module.exports = {"loader":"requestLoader_loader__typ0h","loader__blue":"requestLoader_loader__blue__19oAx"};